var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"main"}},[_c('BreadCrumbs',{attrs:{"pagename":_vm.$t('hosting.main')}}),_c('section',{staticClass:"hosting",attrs:{"id":"hosting"}},[_c('div',{staticClass:"container",attrs:{"data-aos":"fade-up"}},[_c('ul',_vm._l((_vm.$t('hosting.list')),function(it){return _c('li',{key:it},[_vm._v(_vm._s(it))])}),0)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }